import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.scss';
import { BreakpointProvider } from './hooks/useBreakpoint';
import './analytics/firabse';
import { BonusGameRoutes } from './pages/BonusGame';
import Loader from './pages/Education/components/Loader';
import { UserProvider } from './pages/BonusGame/contexts/UserContext';

const Main = lazy(() => import('./App'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy/index'));
const TermsAndUse = lazy(() => import('./pages/TermsOfUse'));
const TermsAndUseApp = lazy(() => import('./pages/TermsOfUseApp'));
const EducationPage = lazy(() => import('src/pages/Education'));
const Article = lazy(() => import('src/pages/Education/views/article'));
const DownloadApk = lazy(() => import('./pages/DownloadApk'));
const AirDrop = lazy(() => import('./pages/AirDrop'));

const root = ReactDOM.createRoot(document.getElementById('root'));

const firstPathSegment = window.location.pathname.split('/')[1];

root.render(
  <BreakpointProvider>
    <BrowserRouter>
      <Suspense fallback={<Loader small />}>
        {firstPathSegment === 'bonus-game' ? (
          <UserProvider>
            <BonusGameRoutes />
          </UserProvider>
        ) : (
          <Routes>
            <Route exact path="/" element={<Main />} />
            <Route path="/terms-of-use" element={<TermsAndUse />} />
            <Route path="/terms-of-use-app" element={<TermsAndUseApp />} />
            <Route path="/privacy-policy-app" element={<PrivacyPolicy />} />
            <Route path="/download-apk" element={<DownloadApk />} />
            <Route path="/airdrop" element={<AirDrop />} />
            <Route path="/education/" element={<EducationPage />} />
            <Route path="/education/:articleId" element={<Article />} />
          </Routes>
        )}
      </Suspense>
    </BrowserRouter>
  </BreakpointProvider>,
);
